import { useContext } from 'react';
import { AttachmentsContext, SetAttachmentsContext } from './Provider';

export const useTsAttachments = () => {
  const ctx = useContext(AttachmentsContext);

  if (!ctx)
    throw new Error(
      'useFilterAttachments должен использоваться внутри AttachmentsContext'
    );

  return ctx;
};

export const useSetTsAttachments = () => {
  const ctx = useContext(SetAttachmentsContext);

  if (!ctx)
    throw new Error(
      'useSetFilterAttachments должен использоваться внутри SetAttachmentsContext'
    );

  return ctx;
};
